import { render, staticRenderFns } from "./SolusiSekolah.vue?vue&type=template&id=84b8993a&"
import script from "./SolusiSekolah.vue?vue&type=script&lang=js&"
export * from "./SolusiSekolah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports